module.exports = __webpack_public_path__ + "media/images/digivent/accreditation-10039a662ff18c202b201a8f3c60eb83.jpg";